import { useState, useEffect, useCallback } from 'react'
import { SERVERS, POLL_INTERVAL_MS } from '../constants.js'
import { healthCheckAll } from '../api.js'

const initialStats = SERVERS.map((s) => ({
  server: s,
  status: 'checking',
  ping: null,
  active: null,
  checkedAt: null,
}))

export function useServerStats() {
  const [stats, setStats] = useState(initialStats)
  const [refreshing, setRefreshing] = useState(false)
  const [lastRefresh, setLastRefresh] = useState(null)

  const refresh = useCallback(async () => {
    setRefreshing(true)
    const results = await healthCheckAll(SERVERS)
    setStats(results)
    setLastRefresh(new Date())
    setRefreshing(false)
  }, [])

  // Initial fetch + polling
  useEffect(() => {
    refresh()
    const id = setInterval(refresh, POLL_INTERVAL_MS)
    return () => clearInterval(id)
  }, [refresh])

  // Derived totals
  const totalBots   = stats.reduce((a, s) => a + (s.active?.count ?? 0), 0)
  const onlineCount = stats.filter((s) => s.status === 'online').length
  const offlineCount = stats.filter((s) => s.status === 'offline').length

  return { stats, refreshing, lastRefresh, refresh, totalBots, onlineCount, offlineCount }
}
